import { BizVehicleItem } from 'src/components/biz-vehicle-item';

export default BizVehicleItem;
